export default {
  initialize: state => ({
    type: 'VIEWS_INITIALIZE',
    state,
  }),
  setViews: views => ({
    type: 'VIEWS_SET_VIEWS',
    views,
  }),
  setAvailableViews: availableViews => ({
    type: 'VIEWS_SET_AVAILABLE_VIEWS',
    availableViews,
  }),
  setFixedViews: fixedViews => ({
    type: 'VIEWS_SET_FIXED_VIEWS',
    fixedViews,
  }),
  setDefaultView: defaultView => ({
    type: 'VIEWS_SET_DEFAULT_VIEW',
    defaultView,
  }),
  setActiveView: activeView => ({
    type: 'VIEWS_SET_ACTIVE_VIEW',
    activeView,
  }),
  setSelectedViewSelection: selectedViewSelection => ({
    type: 'VIEWS_SET_SELECTED_VIEW_SELECTION',
    selectedViewSelection,
  }),
};
